import ApiKeysTableItem from './ApiKeysTableItem'

export default ApiKeysTableItem
